import { WIZARD_STEP_NAME, WIZARD_STEP_PATH } from "../router/path/wizard";

export const WIZARD_STATES = {
  done: "done",
  next: "next",
  active: "active",
  finish: "finish",
};

export const WIZARD_ACTIONS = {
  previous: "prev",
  next: "next",
};

export const WIZARD_STEPS_ADMIN = [
  {
    id: WIZARD_STEP_PATH.ACCOUNT_SELECTION,
    status: WIZARD_STATES.active,
    name: WIZARD_STEP_NAME.ACCOUNT_SELECTION,
    stepNumber: 1,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_SOURCE,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_SOURCE,
    stepNumber: 2,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_TARGET,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_TARGET,
    stepNumber: 3,
  },
  {
    id: WIZARD_STEP_PATH.ENTITIES_SELECTION,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.ENTITIES_SELECTION,
    stepNumber: 4,
  },
  {
    id: WIZARD_STEP_PATH.MAPPING_SETUP,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.MAPPING_SETUP,
    stepNumber: 5,
  },
  {
    id: WIZARD_STEP_PATH.OPTIONS_SELECTION,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.OPTIONS_SELECTION,
    stepNumber: 6,
  },
  {
    id: WIZARD_STEP_PATH.DEMO_MIGRATION,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.DEMO_MIGRATION,
    stepNumber: 7,
  },
  {
    id: WIZARD_STEP_PATH.FINISH,
    status: WIZARD_STATES.finish,
    name: WIZARD_STEP_NAME.FINISH,
    stepNumber: 8,
  },
];

export const WIZARD_STEPS_ADMIN_SHORT = [
  {
    id: WIZARD_STEP_PATH.ACCOUNT_SELECTION,
    status: WIZARD_STATES.active,
    name: WIZARD_STEP_NAME.ACCOUNT_SELECTION,
    stepNumber: 1,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_SOURCE,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_SOURCE,
    stepNumber: 2,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_TARGET,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_TARGET,
    stepNumber: 3,
  },
  {
    id: WIZARD_STEP_PATH.FINISH,
    status: WIZARD_STATES.finish,
    name: WIZARD_STEP_NAME.FINISH,
    stepNumber: 4,
  },
];

export const WIZARD_STEPS_ADMIN_SHORT_FILES = [
  {
    id: WIZARD_STEP_PATH.ACCOUNT_SELECTION,
    status: WIZARD_STATES.active,
    name: WIZARD_STEP_NAME.ACCOUNT_SELECTION,
    stepNumber: 1,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_SOURCE,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_SOURCE,
    stepNumber: 2,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_TARGET,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_TARGET,
    stepNumber: 3,
  },
  {
    id: WIZARD_STEP_PATH.ENTITIES_SELECTION,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.ENTITIES_SELECTION,
    stepNumber: 4,
  },
  {
    id: WIZARD_STEP_PATH.FINISH,
    status: WIZARD_STATES.finish,
    name: WIZARD_STEP_NAME.FINISH,
    stepNumber: 5,
  },
];

export const WIZARD_STEPS_ADMIN_SHORT_FILES_MAPPING = [
  {
    id: WIZARD_STEP_PATH.ACCOUNT_SELECTION,
    status: WIZARD_STATES.active,
    name: WIZARD_STEP_NAME.ACCOUNT_SELECTION,
    stepNumber: 1,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_SOURCE,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_SOURCE,
    stepNumber: 2,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_TARGET,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_TARGET,
    stepNumber: 3,
  },
  {
    id: WIZARD_STEP_PATH.ENTITIES_SELECTION,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.ENTITIES_SELECTION,
    stepNumber: 4,
  },
  {
    id: WIZARD_STEP_PATH.MAPPING_SETUP,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.MAPPING_SETUP,
    stepNumber: 5,
  },
  {
    id: WIZARD_STEP_PATH.FINISH,
    status: WIZARD_STATES.finish,
    name: WIZARD_STEP_NAME.FINISH,
    stepNumber: 6,
  },
];

export const WIZARD_STEPS_USER = [
  {
    id: WIZARD_STEP_PATH.SELECT_SOURCE,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_SOURCE,
    stepNumber: 1,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_TARGET,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_TARGET,
    stepNumber: 2,
  },
  {
    id: WIZARD_STEP_PATH.ENTITIES_SELECTION,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.ENTITIES_SELECTION,
    stepNumber: 3,
  },
  {
    id: WIZARD_STEP_PATH.MAPPING_SETUP,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.MAPPING_SETUP,
    stepNumber: 4,
  },
  {
    id: WIZARD_STEP_PATH.OPTIONS_SELECTION,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.OPTIONS_SELECTION,
    stepNumber: 5,
  },
  {
    id: WIZARD_STEP_PATH.DEMO_MIGRATION,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.DEMO_MIGRATION,
    stepNumber: 6,
  },
  {
    id: WIZARD_STEP_PATH.FINISH,
    status: WIZARD_STATES.finish,
    name: WIZARD_STEP_NAME.FINISH,
    stepNumber: 7,
  },
];

export const WIZARD_STEPS_USER_SHORT = [
  {
    id: WIZARD_STEP_PATH.SELECT_SOURCE,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_SOURCE,
    stepNumber: 1,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_TARGET,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_TARGET,
    stepNumber: 2,
  },
  {
    id: WIZARD_STEP_PATH.FINISH,
    status: WIZARD_STATES.finish,
    name: WIZARD_STEP_NAME.FINISH,
    stepNumber: 3,
  },
];

export const WIZARD_STEPS_USER_SHORT_FILES = [
  {
    id: WIZARD_STEP_PATH.SELECT_SOURCE,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_SOURCE,
    stepNumber: 1,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_TARGET,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_TARGET,
    stepNumber: 2,
  },
  {
    id: WIZARD_STEP_PATH.ENTITIES_SELECTION,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.ENTITIES_SELECTION,
    stepNumber: 3,
  },
  {
    id: WIZARD_STEP_PATH.FINISH,
    status: WIZARD_STATES.finish,
    name: WIZARD_STEP_NAME.FINISH,
    stepNumber: 4,
  },
];

export const WIZARD_STEPS_USER_SHORT_FILES_MAPPING = [
  {
    id: WIZARD_STEP_PATH.SELECT_SOURCE,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_SOURCE,
    stepNumber: 1,
  },
  {
    id: WIZARD_STEP_PATH.SELECT_TARGET,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.SELECT_TARGET,
    stepNumber: 2,
  },
  {
    id: WIZARD_STEP_PATH.ENTITIES_SELECTION,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.ENTITIES_SELECTION,
    stepNumber: 3,
  },
  {
    id: WIZARD_STEP_PATH.MAPPING_SETUP,
    status: WIZARD_STATES.next,
    name: WIZARD_STEP_NAME.MAPPING_SETUP,
    stepNumber: 4,
  },
  {
    id: WIZARD_STEP_PATH.FINISH,
    status: WIZARD_STATES.finish,
    name: WIZARD_STEP_NAME.FINISH,
    stepNumber: 5,
  },
];

export const stepsMap = {
  admin: {
    default: WIZARD_STEPS_ADMIN,
    recent: {
      file: {
        mapping: WIZARD_STEPS_ADMIN_SHORT_FILES_MAPPING,
        noMapping: WIZARD_STEPS_ADMIN_SHORT_FILES,
      },
      noFile: WIZARD_STEPS_ADMIN_SHORT,
    },
  },
  user: {
    default: WIZARD_STEPS_USER,
    recent: {
      file: {
        mapping: WIZARD_STEPS_USER_SHORT_FILES_MAPPING,
        noMapping: WIZARD_STEPS_USER_SHORT_FILES,
      },
      noFile: WIZARD_STEPS_USER_SHORT,
    },
  },
};
